(() => {
  // assets/custom/js/header.js
  var Header = class {
    static init() {
      this.header = document.querySelector("header");
      if (!this.header)
        return;
      this.timeElement = this.header.querySelector(".time-span");
      if (this.timeElement) {
        this.updateTime();
      }
    }
    static updateTime() {
      const now = /* @__PURE__ */ new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      this.timeElement.textContent = `${hours}:${minutes}:${seconds}`;
      setTimeout(() => this.updateTime(), 1e3);
    }
  };

  // assets/custom/js/main.js
  window.addEventListener("DOMContentLoaded", () => {
    Header.init();
  });
})();
